module.exports = __webpack_public_path__ + "img/harbor-zone.ce1e3f7b.jpg";